import { useEffect, useState } from "react";
import { Bell, Megaphone, X } from "lucide-react";
import { supabase } from "./supabaseClient";

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("dismissedNotifications") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    supabase
      .from("notifications")
      .select("id, title, link, message, image_url, created_at")
      .eq("active", true)
      .order("created_at", { ascending: false })
      .then(({ data }) => setNotifications(data ?? []));
  }, []);

  function dismiss(id) {
    const next = [...dismissed, id];
    setDismissed(next);
    sessionStorage.setItem("dismissedNotifications", JSON.stringify(next));
  }

  const visible = notifications.filter((n) => !dismissed.includes(n.id));
  if (visible.length === 0) return null;

  return (
    <section className="bg-gradient-to-b from-slate-900 to-slate-800 border-b border-white/10">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-3 flex items-center gap-2">
          <Megaphone className="h-5 w-5 text-amber-400 shrink-0" />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400">Club Notifications</p>
        </div>
        <div className="space-y-3">
        {visible.map((n) => (
          <div
            key={n.id}
            className="flex items-start gap-3 rounded-2xl border border-amber-400/30 bg-gradient-to-br from-amber-400/10 to-amber-400/5 px-5 py-4 panel-lift"
          >
            <Bell className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
            <div className="flex-1 min-w-0">
              {n.title && (
                <p className="font-semibold text-amber-300 text-sm">{n.title}</p>
              )}
              {n.image_url && (
                <img src={n.image_url} alt="" className="mt-2 max-h-64 rounded-xl border border-amber-400/20" />
              )}
              <p className="text-sm text-slate-200 mt-0.5">{n.message}</p>
              {n.link && (
                <a
                  href={n.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 inline-block text-sm font-semibold text-cyan-300 hover:text-white"
                >
                  Read more
                </a>
              )}
            </div>
            <button
              onClick={() => dismiss(n.id)}
              className="shrink-0 rounded-lg p-1 text-slate-400 hover:text-white transition"
              title="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
        </div>
      </div>
    </section>
  );
}
